import {IMeetingNotify} from '@/types/document/notification';
import sdk from '@/sdk';
import * as store from '@/store';

export interface IMeetingInfo {
    createTime: number;
    creatorUser: {
        userGuid: string;
        name: string;
    };
    refer?: string;
}

export function getMeetingInfo(notifyData: IMeetingNotify): IMeetingInfo {
    const {
        members = [],
        latestMilestoneVersionInfo,
        versionInfo,
        refer,
    } = notifyData.data || {};
    const {
        updateMembers = [],
        updateTime,
    } = latestMilestoneVersionInfo || versionInfo || {};

    const creatorUserId = updateMembers[0]; // 第一个是会议发起者

    const meetingInfo = {
        createTime: updateTime * 1000, // 这个其实是createTime，单位是s，哭了
        creatorUser: members.filter(member => member.userGuid === creatorUserId)[0] || {}, // 筛选出会议发起人
        refer,
    };
    return meetingInfo;
}

export function showOpenTip(meetingInfo: IMeetingInfo): boolean {
    const currentUser = sdk.as.user;
    const currentTime = (new Date()).getTime();

    const isCreator = meetingInfo?.creatorUser.userGuid === currentUser?.userGuid;
    const isInit = currentTime - meetingInfo.createTime <= 2000; // 2s内判定为停留在当前页面收到广播，超过2s判定中途进入
    return !isCreator && isInit; // 会议发起人和中途进入会议模式的不需要弹出提示
}

export function showCloseTip(meetingInfo: IMeetingInfo): boolean {
    const currentUser = sdk.as.user;
    const isCreator = meetingInfo?.creatorUser.userGuid === currentUser?.userGuid;
    return !isCreator;
}

// 获取会议模式中的doc列表并更新到store
export async function getDocsInMeeting(repository?: Repository) {
    const curRepository = store.getCurRepository() || repository;
    if (!curRepository) {
        return null;
    }
    // toc mvp版本需要屏蔽这个接口
    const isTocPage = window.isTocPage;
    if (isTocPage) {
        return null;
    }
    try {
        const ksServer = await sdk.getKsServer(curRepository);
        const result = await ksServer.getDocsInMeeting();
        store.setDocsInMeeting(result.docs);
        return result.docs;
    } catch (err) {
        console.error('get meeting docs error:', err);
        return null;
    }
}
